module.exports = __webpack_public_path__ + "img/boat-1.f1e832fd.png";